export default __webpack_public_path__ + "static/media/Janitor.e1c212d1.jpg";